import React, { useState } from "react"
import { Button, Tooltip } from "@mantine/core"
import { IconCheck, IconCopy } from "@tabler/icons-react"
import { capturePlatformPromptCopy, runAfterSuccessfulAction } from "../../../analytics"

type CopyPromptButtonProps = {
  // The row's `prompt`, copied verbatim: it is the text the directions eval
  // sends, so what lands in the builder's chat is the tested prompt.
  prompt: string
  // The platform row's id, for analytics only (platform_prompt_copy).
  platformId: string
  label: string
  size?: "sm" | "md" | "lg"
  variant?: "filled" | "default"
}

// Copy prompt (contract v8): for an AI builder such as v0, the one message to
// paste into its chat. No trimming, no wrapping, nothing added.
export const CopyPromptButton: React.FC<CopyPromptButtonProps> = ({
  prompt,
  platformId,
  label,
  size = "sm",
  variant = "default"
}) => {
  const [copied, setCopied] = useState(false)
  const iconSize = size === "sm" ? 16 : 18

  // Like the agent-directions copy, the event follows only a clipboard write
  // that succeeded.
  const copy = async () => {
    const ok = await runAfterSuccessfulAction(
      () => navigator.clipboard.writeText(prompt),
      () => capturePlatformPromptCopy(platformId)
    )
    setCopied(ok)
    if (ok) window.setTimeout(() => setCopied(false), 1800)
  }

  return (
    <Tooltip
      label={copied ? "Prompt copied" : `Copy the prompt to paste into ${label}`}
      withArrow
      openDelay={200}
    >
      <Button
        className="or-copy-prompt"
        size={size}
        variant={variant}
        leftSection={copied ? <IconCheck size={iconSize} /> : <IconCopy size={iconSize} />}
        onClick={() => void copy()}
      >
        {copied ? "Prompt copied" : "Copy prompt"}
      </Button>
    </Tooltip>
  )
}
